/**
 * Returns a DOMRect describing the element's bounds relative to either the viewport (default) or the page.
 *
 * @param {Element} element - A DOM Element
 * @param {Boolean} inPage - Flag, if bounds position should be relative to the page
 * @param {Object} rect - Optional rectangle object to copy values into
 */
const getElementBounds = (element, inPage = false, rect = null) => {
  const bounds = element.getBoundingClientRect()

  rect = rect || {}
  rect.x = rect.left = bounds.left + (inPage ? window.pageXOffset : 0)
  rect.y = rect.top = bounds.top + (inPage ? window.pageYOffset : 0)
  rect.width = bounds.width
  rect.height = bounds.height
  return rect
}

export default getElementBounds
